import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { createStore } from "redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import conversationReducer from "./redux/reducers/conversationReducer";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const store = createStore(conversationReducer);

root.render(
  <BrowserRouter>
    <ToastContainer />
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
